import React from 'react';

import { Box, Button, ButtonProps } from '@mui/material';

type RespButtonProps = ButtonProps;

const RespButton = (props: RespButtonProps) => (
    <Button
        {...props}
        sx={(t) => ({
            margin: t.spacing(1),
            [t.breakpoints.down('md')]: {
                minWidth: 32,
                paddingLeft: 1,
                paddingRight: 1,
                '& .MuiButton-startIcon': { margin: 0 }
            }
        })}
    >
        <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
            {props.children}
        </Box>
    </Button>
);

export default RespButton;
